<div class="loader-container">
  <img src="/assets/images/Loading_Animation_Ambulance.gif" />
</div>
